<template>
  <header class='header' />
</template>

<script>
export default {
  name: 'SiteHeader',
  props: { },
  methods: { }
}
</script>

<style lang="less" scoped>
.header {
  height: 64px;
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: rgba(255, 255, 255, 0.7);
}

.header input, .header select {
  outline: none;
  border: 0px none transparent;
  background: none;
  padding: 4px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.5);
  margin: 0 16px 0 0;
  text-align: left;
}

// @media(max-width: 768px) {
  .header {
    padding-left: 64px;
  }
// }


</style>
